module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "username",
      "label": "E-mail Address",
      "validation": _vm.$v.user.username
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.user.password
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-password', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "validation": _vm.$v.confirmPassword
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "name",
      "label": "First Name",
      "validation": _vm.$v.user.name
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-6",
    attrs: {
      "name": "surname",
      "label": "Last Name",
      "validation": _vm.$v.user.surname
    },
    model: {
      value: (_vm.user.surname),
      callback: function($$v) {
        _vm.$set(_vm.user, "surname", $$v)
      },
      expression: "user.surname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "cellularNumber",
      "label": "Cellular Number",
      "validation": _vm.$v.user.cellPhoneNumber
    },
    model: {
      value: (_vm.user.cellPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "cellPhoneNumber", $$v)
      },
      expression: "user.cellPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-switch', {
    attrs: {
      "name": "identityType",
      "options": _vm.identityTypes
    },
    model: {
      value: (_vm.user.identityType),
      callback: function($$v) {
        _vm.$set(_vm.user, "identityType", $$v)
      },
      expression: "user.identityType"
    }
  })], 1)]), _vm._v(" "), (_vm.user.identityType === 'IDDOC') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "identityNumber",
      "label": "Identity Number",
      "validation": _vm.$v.user.idNumber
    },
    model: {
      value: (_vm.user.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "idNumber", $$v)
      },
      expression: "user.idNumber"
    }
  })], 1)]) : (_vm.user.identityType === 'PASSPORT') ? _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "passportNumber",
      "label": "Passport Number",
      "validation": _vm.$v.user.passportNumber
    },
    model: {
      value: (_vm.user.passportNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "passportNumber", $$v)
      },
      expression: "user.passportNumber"
    }
  }), _vm._v(" "), _c('input-select', {
    attrs: {
      "name": "passportCountry",
      "label": "Passport Country",
      "options": _vm.countries,
      "validation": _vm.$v.passportCountry,
      "loading": _vm.loadingCountries
    },
    model: {
      value: (_vm.passportCountry),
      callback: function($$v) {
        _vm.passportCountry = $$v
      },
      expression: "passportCountry"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "discipline",
      "label": "Select Discipline",
      "options": _vm.disciplines,
      "validation": _vm.$v.discipline,
      "loading": _vm.loadingDisciplines
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadSpecialities($event)
      }
    },
    model: {
      value: (_vm.discipline),
      callback: function($$v) {
        _vm.discipline = $$v
      },
      expression: "discipline"
    }
  })], 1), _vm._v(" "), (_vm.discipline) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "speciality",
      "label": "Select Speciality",
      "options": _vm.specialities,
      "validation": _vm.$v.speciality,
      "loading": _vm.loadingSpecialities
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadGrades($event)
      }
    },
    model: {
      value: (_vm.speciality),
      callback: function($$v) {
        _vm.speciality = $$v
      },
      expression: "speciality"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "grade",
      "label": "Select Speciality Grade",
      "options": _vm.grades,
      "validation": _vm.$v.specialityGrade,
      "loading": _vm.loadingGrades
    },
    model: {
      value: (_vm.specialityGrade),
      callback: function($$v) {
        _vm.specialityGrade = $$v
      },
      expression: "specialityGrade"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hpcsaNumber",
      "label": "HPCSA Number",
      "validation": _vm.$v.user.hpcsaNumber
    },
    model: {
      value: (_vm.user.hpcsaNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "hpcsaNumber", $$v)
      },
      expression: "user.hpcsaNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "practiceNumber",
      "label": "Practice Number",
      "validation": _vm.$v.user.prNumber
    },
    model: {
      value: (_vm.user.prNumber),
      callback: function($$v) {
        _vm.$set(_vm.user, "prNumber", $$v)
      },
      expression: "user.prNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "academicSector",
      "label": "Are you in the Academic Sector",
      "options": _vm.academicSectorOptions,
      "validation": _vm.$v.academicSector
    },
    nativeOn: {
      "change": function($event) {
        return _vm.loadRolesAndInstitutions($event)
      }
    },
    model: {
      value: (_vm.academicSector),
      callback: function($$v) {
        _vm.academicSector = $$v
      },
      expression: "academicSector"
    }
  })], 1), _vm._v(" "), (_vm.inAcademicSector) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "institution",
      "label": "Select Training Institution",
      "options": _vm.institutions,
      "validation": _vm.$v.trainingInstitution,
      "loading": _vm.loadingInstitutions
    },
    model: {
      value: (_vm.trainingInstitution),
      callback: function($$v) {
        _vm.trainingInstitution = $$v
      },
      expression: "trainingInstitution"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-select', {
    attrs: {
      "name": "role",
      "label": "Select Role",
      "options": _vm.roles,
      "validation": _vm.$v.role,
      "loading": _vm.loadingRoles
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1), _vm._v(" "), (_vm.traineeSignup) ? [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "traineePostNumber",
      "label": "Trainee Post Number",
      "validation": _vm.$v.trainee.traineePostNumber
    },
    model: {
      value: (_vm.trainee.traineePostNumber),
      callback: function($$v) {
        _vm.$set(_vm.trainee, "traineePostNumber", $$v)
      },
      expression: "trainee.traineePostNumber"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.displayRegistarAppointmentField) ? [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "appointmentDate",
      "label": "Date of appointment as registrar",
      "type": "date",
      "min-date": _vm.registrarAppointmentMinDate,
      "max-date": _vm.registrarAppointmentMaxDate,
      "validation": _vm.$v.trainee.registrarAppointmentDate
    },
    model: {
      value: (_vm.trainee.registrarAppointmentDate),
      callback: function($$v) {
        _vm.$set(_vm.trainee, "registrarAppointmentDate", $$v)
      },
      expression: "trainee.registrarAppointmentDate"
    }
  })], 1)] : (_vm.role && _vm.role.name === 'SUPERVISOR') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "clinicalUnit",
      "label": "Clinical Unit",
      "validation": _vm.$v.supervisor.clinicalUnit
    },
    model: {
      value: (_vm.supervisor.clinicalUnit),
      callback: function($$v) {
        _vm.$set(_vm.supervisor, "clinicalUnit", $$v)
      },
      expression: "supervisor.clinicalUnit"
    }
  })], 1), _vm._v(" "), (_vm.trainingInstitution && _vm.speciality) ? _c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "hod",
      "label": "Head of Department",
      "validation": _vm.$v.hod
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openHodSearchModal($event)
      }
    },
    model: {
      value: (_vm.hodFullName),
      callback: function($$v) {
        _vm.hodFullName = $$v
      },
      expression: "hodFullName"
    }
  }), _vm._v(" "), _c('hod-search-modal', {
    attrs: {
      "open": _vm.hodSearchModalOpen,
      "speciality-id": _vm.speciality.id,
      "training-institute-id": _vm.trainingInstitution.id
    },
    on: {
      "close": _vm.closeHodSearchModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayHodWarning) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e()]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-sm-offset-3"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I have read and accept the\n          "), _c('a', {
    staticClass: "highlight",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTermsModal($event)
      }
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "signUpSubmit",
      "loading": _vm.loading
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('academic-terms-modal', {
    attrs: {
      "open": _vm.termsModalOpen,
      "id": "openTermsModal"
    },
    on: {
      "close": _vm.closeTermsModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n              The email entered belongs to an HOD in a different training institution or speciality. Click register if you are sure you want to continue sending them the access request.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73378a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/forms/AcademicForm.vue
// module id = 662
// module chunks = 5